import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { NewFeature } from '@lemon/core-firebase/model/kayttaja'
import { DateService } from '@lemon/core/service/date.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { UserSettingsService } from 'app/_angular/service/user-settings.service'
import { take } from 'rxjs'

export interface AsiakasKyselyDialogData {
  kayttajaUid: string
  kayttajaAsiakasAvain: string
  skipShownUntilUpdate?: boolean
  voimassaAsti?: Date
}

@Component({
  selector: 'asiakaskysely-dialog',
  templateUrl: './asiakaskysely.dialog.html',
  styleUrls: ['./asiakaskysely.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasKyselyDialog implements OnInit {
  voimassaAstiFormatted?: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AsiakasKyselyDialogData,
    private _dialogRef: MatDialogRef<AsiakasKyselyDialog, 'action-saved'>,
    private _userSettingsService: UserSettingsService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _dateService: DateService,
  ) {}

  ngOnInit(): void {
    if (this.data.voimassaAsti) {
      this.voimassaAstiFormatted = this._dateService.muotoilePaivaDate(this.data.voimassaAsti, 'fi')
    }

    this._dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(closeType => {
        if (closeType === 'action-saved' || this.data.skipShownUntilUpdate) {
          return
        }
        return this._userSettingsService.setShownUntil(NewFeature.ASIAKASKYSELY, 14, this.data.kayttajaAsiakasAvain, this.data.kayttajaUid, this._firebaseLemonaid)
      })
  }

  async vastaa(event: MouseEvent) {
    event?.stopImmediatePropagation()
    event?.stopPropagation()
    window.scrollTo(0, 0)

    this._avaaLinkkiOhitaPopupEsto('https://forms.office.com/e/4iEFSydqe5')

    if (!this.data.skipShownUntilUpdate) {
      await this._userSettingsService.setShownUntil(NewFeature.ASIAKASKYSELY, 14, this.data.kayttajaAsiakasAvain, this.data.kayttajaUid, this._firebaseLemonaid)
    }

    this._dialogRef.close('action-saved')
  }

  async myohemmin(event: MouseEvent) {
    event?.preventDefault()
    event?.stopImmediatePropagation()
    event?.stopPropagation()
    window.scrollTo(0, 0)

    if (!this.data.skipShownUntilUpdate) {
      await this._userSettingsService.setShownUntil(NewFeature.ASIAKASKYSELY, 14, this.data.kayttajaAsiakasAvain, this.data.kayttajaUid, this._firebaseLemonaid)
    }
    this._dialogRef.close('action-saved')
  }

  // Ohittaa selaimen pop-up eston (ei käytetä window.open), jotta linkki aukeaa varmasti heti uuteen ikkunaan
  private _avaaLinkkiOhitaPopupEsto(url: string) {
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.click()
  }
}
